import { GlobalOutlined, MailOutlined } from '@ant-design/icons';
import React from 'react';
import { DataSourceType } from 'shared/services/prisma/types';

const DataSourceIcon = ({ type }) => {
  let icon = null;

  if (type === DataSourceType.Website) {
    icon = <GlobalOutlined />;
  }
  if (type === DataSourceType.Cx) {
    icon = <MailOutlined />;
  }

  return icon;
};

export default DataSourceIcon;
